import React from "react";
import styles from "./ErrorFallBack.module.css";
import i18n from "../Services/i18n";

const ErrorIllustration = () => (
  // Petite illu SVG “décontractée”
  <svg
    className={styles.illustration}
    viewBox="0 0 240 160"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <rect x="10" y="20" width="220" height="120" rx="12" fill="#EEF6F8" />
    <rect x="24" y="34" width="192" height="16" rx="8" fill="#D9EEF2" />
    <rect x="24" y="58" width="160" height="10" rx="5" fill="#C9E4EA" />
    <rect x="24" y="76" width="110" height="10" rx="5" fill="#C9E4EA" />
    <g transform="translate(160,84)">
      <circle r="22" fill="#137C8B" />
      <path
        d="M-6 -4 L6 8 M6 -4 L-6 8"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </g>
    <g transform="translate(70,110)">
      <path
        d="M0 0 q20 12 40 0"
        stroke="#7A90A4"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="0" cy="-10" r="4" fill="#7A90A4" />
      <circle cx="40" cy="-10" r="4" fill="#7A90A4" />
    </g>
  </svg>
);

const ErrorFallback = ({ onRetry }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <ErrorIllustration />
        <h1 className={styles.title}>{i18n.t("error.generic.title")}</h1>
        <p className={styles.text}>{i18n.t("error.generic.description")}</p>

        <div className={styles.actions}>
          <button className={styles.primary} onClick={onRetry}>
            {i18n.t("error.generic.action.reload")}
          </button>
          {/* Optionnel : si tu as une page statut/contact */}
          {/* <a className={styles.link} href="/status">
            {i18n.t("error.generic.action.status")}
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
